import { render, staticRenderFns } from "./lawyerLogin.vue?vue&type=template&id=57afaa7e&scoped=true"
import script from "./lawyerLogin.vue?vue&type=script&lang=js"
export * from "./lawyerLogin.vue?vue&type=script&lang=js"
import style0 from "./lawyerLogin.vue?vue&type=style&index=0&id=57afaa7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57afaa7e",
  null
  
)

export default component.exports